/**
 * Public Vault page for an archived link. Shared by LinkCard (embed closure —
 * keep this file i18n-free) and the quick-actions handler in Bookmarks.
 * Returns null when the link was never vaulted.
 */
export function vaultMetaUrl(link) {
  const vaultId = link && (link.vaultId || link.vault_id)
  return vaultId ? `https://vault.linkflare.io/meta/${vaultId}.html` : null
}
